import ImageWithFallback from '../shared/ImageWithFallback';
export default function OfflineErrorScreen() {
  return <div data-sentry-component="OfflineErrorScreen" data-sentry-source-file="OfflineErrorScreen.tsx">
      <div className='h-[100vh] py-6 bg-genius-cream-foreground z-80 relative overflow-auto rounded-b-3xl purple-gradient-error'>
        <div className='ta-c h-[600px] flex items-center w-[100%]'>
          <div className='w-full'>
            <ImageWithFallback height={83} width={83} src={'/static/images/error.png'} alt={'error'} className={`mt-10 transition-opacity duration-500`} data-sentry-element="ImageWithFallback" data-sentry-source-file="OfflineErrorScreen.tsx" />

            <div className='mw-[288px] px-4'>
              <p className={`mt-[100px] text-genius-gradient text-[24px] font-semibold leading-8`}>
                Looks like you're offline!
                <br />
                Please check your network connection.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}